define.alias("shared/components/shared/ui/switcher/trigger", "settings/components/shared/ui/switcher/trigger");